module.exports = __webpack_public_path__ + "img/modalresult-avanzar.38005485.svg";